<template>
	<div class="header-container width-100 display-flex flex-row flex-align-center flex-justify-space-between">
		<AppDropdownMenu left bottom absolute v-bind="$attrs" min-width="230" v-on="$listeners" :nudge-bottom="25" :items="menuItems">
			<template #activator>
				<AddNewWidgetElement />
			</template>
		</AppDropdownMenu>

		<AnemicButton @click="$emit('show-preview')" class="icon-and-text-button flex-centerize">
			<SIcon class="button-icon mr-1" name="modal-preview" :width="14" />
			Preview
		</AnemicButton>
	</div>
</template>

<script>
import AddNewWidgetElement from './WidgetFormHeader/AddNewWidgetElement';

export default {
	name: 'ConfigurationEditHeader',
	components: {
		AddNewWidgetElement,
	},
	methods: {
		addNewBlock(setupType) {
			this.$emit('add-new-block', setupType);
		},
	},
	props: {},
	data() {
		return {
			menuItems: [
				{ text: 'Add to general setup', onClick: () => this.addNewBlock('general') },
				{ text: 'Add to personal setup', onClick: () => this.addNewBlock('personal') },
			],
		};
	},
};
</script>

<style lang="scss" scoped>
.header-container {
	height: 66px;
	padding: 0px 24px;
	background: var(--primary-bg-color);
	border: 1px solid var(--border-color);
	border-top: 0px;
}

.icon-and-text-button {
	font-size: 12px !important;
	color: var(--primary-font-color) !important;

	padding: 10px 8px !important;
	border-radius: 8px !important;
	background: var(--bg-color) !important;
	border: 1px solid var(--button-border) !important;

	.button-icon {
		margin-top: 2px;
	}
}
</style>
